<mbs-modal
  [isCustomModal]="true"
  [showFooter]="false"
  [showHeader]="false">
  <div modal-body>
    <div class="p-0">
      <div class="row">
        <mbs-tile
          class="add-destination-tile col-6 px-1 cursor-pointer"
          [data]="null"
          [disabled]="!ability.can('read', PermissionsEnum.Storage)"
          [headerTemplate]="fileSystemTileTemplate"
          [hoverAble]="true"
          [selectable]="false"
          [showBody]="false"
          (click)="addFileSystemDestination()">
          <ng-template #fileSystemTileTemplate>
            <div class="d-flex flex-column w-100 h-100 p-2">
              <div class="d-flex align-items-center">
                <span class="mr-2 ico ico-hdd-local"></span>
                <span class="fw-bold">{{ 'wizards:destinationPlusRetention.addNewDestination.title.fileSystem' | i18next }}</span>
              </div>

              <div class="pt-2 pl-2">
                <ul class="mb-0">
                  @for (str of addNewDestinationDescription.fileSystem; track $index) {
                    <li>{{ str }}</li>
                  }
                </ul>
              </div>

              <div class="mt-auto pl-3 pt-3">
                <span class="mr-2 fa fa-thumbs-o-up"></span>
                <span>{{ 'wizards:destinationPlusRetention.addNewDestination.bestFor.fileSystem' | i18next }}</span>
              </div>
            </div>
          </ng-template>
        </mbs-tile>
        <mbs-tile
          class="add-destination-tile col-6 px-1 cursor-pointer"
          [data]="null"
          [disabled]="isReadOnlySuperAdmin || (isUnix && !isNetBuild)"
          [headerTemplate]="localFileSystemTileTemplate"
          [hoverAble]="true"
          [selectable]="false"
          [showBody]="false"
          (click)="addLocalFileSystemDestination()">
          <ng-template #localFileSystemTileTemplate>
            <div class="d-flex flex-column w-100 h-100 p-2">
              <div class="d-flex align-items-center">
                <span class="mr-2 ico ico-hdd-solid"></span>
                <span class="fw-bold">{{ 'wizards:destinationPlusRetention.addNewDestination.title.localFileSystem' | i18next }}</span>
              </div>

              <div class="pt-2 pl-2">
                <ul class="mb-0">
                  @for (str of addNewDestinationDescription.localFileSystem; track $index) {
                    <li>{{ str }}</li>
                  }
                </ul>
              </div>

              <div class="mt-auto pl-3 pt-3">
                <span class="mr-2 fa fa-thumbs-o-up"></span>
                <span>{{ 'wizards:destinationPlusRetention.addNewDestination.bestFor.localFileSystem' | i18next }}</span>
              </div>
            </div>
          </ng-template>
        </mbs-tile>
      </div>
      <div class="row">
        <a
          class="col mt-3 pl-1"
          target="_blank"
          [helpLink]="'/billing-storage/file-system-storage'">
          {{ 'shared:buttons.learnMore' | i18next }}
        </a>
      </div>
    </div>
  </div>
</mbs-modal>
